import React, { useMemo, useState } from 'react';
import { useData } from '../contexts/DataContext';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../components/ui/select';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Image as ImageIcon } from 'lucide-react';
import GenericHero from '../components/GenericHero';
import ModernGallery from '../components/ModernGallery';

const CURATED_GALLERY_IMAGES = [
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/e828afb499a63409ead8c06615281b13b.jpg?updatedAt=1763144229394",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/43867b51693def57ebba9abc7ba57638a.jpg?updatedAt=1763144226753",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/63618d04c199e255ccb079fcf046b537a.jpg?updatedAt=1763144226470",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/c1642679d7e8aa2b8321286eab837c27ab.jpg?updatedAt=1763144225954",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/89f2f0539dd40b343ef133c82854b1a8b.jpg?updatedAt=1763144224387",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/63618d04c199e255ccb079fcf046b537abc.jpg?updatedAt=1763144224450",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/cb4954cda47ea205d8c3de2b188d1aad.jpg?updatedAt=1763144223835",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/e868422d41c58b6b0bd8ee693e691380b.jpg?updatedAt=1763144222388",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/91b5e26a107fb1f5f8c895e79d635e61b.jpg?updatedAt=1763144221778",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/02e5644b444dd4d70d9cc5ff30ee9dcba.jpg?updatedAt=1763144221177",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/3a5bb7f4ec479f6e6327d0089cc25485ab.jpg?updatedAt=1763144220798",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/8dc3543652397bbb44a8b5109899382fa.jpg?updatedAt=1763144219321",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/da1ef6a87da2ae6163c758c5198a9afdb.jpg?updatedAt=1763144219241",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/e828afb499a63409ead8c06615281b13a.jpg?updatedAt=1763144218674",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/cb4954cda47ea205d8c3de2b188d1aada.jpg?updatedAt=1763144218631",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/674f5607186db833a9462ce2f585edf2.jpg?updatedAt=1763144217896",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/031781a0479006f4fa35b045357ea69f.jpg?updatedAt=1763144217289",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/cb2baf96206eb2102bed98f0260c61b8ab.jpg?updatedAt=1763144216693",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/a69a30a0368ce3f3390c30b74715e767ab.jpg?updatedAt=1763144216856",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/9221a0790674489251e5e0ca813a3181b.jpg?updatedAt=1763144215531",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/fc667226f17bf6a5648677217cb564fd.jpg?updatedAt=1763144215376",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/videoframe_10102%20copy.jpg?updatedAt=1763144214508",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/be7327d9652a6596771c16992db5acaea.jpg?updatedAt=1763144214428",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/0065b72467c9a946ef6bc7f879c6ab2ea.jpg?updatedAt=1763144214053",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/3c8be252fff046adcb0aea3606147aa6a.jpg?updatedAt=1763144213441",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/e1e93662bcb2db4b670e4640dbf3a5ffb.jpg?updatedAt=1763144213501",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/c52b2283cf1c8bba65e9aed408997797ab.jpg?updatedAt=1763144213533",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/fc667226f17bf6a5648677217cb564fdabc.jpg?updatedAt=1763144212399",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/96495cbc08d65cb6362989e3ba63d32bcb.jpg?updatedAt=1763144211486",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/27056b9b31459bc8fcbe0526f38a9503.jpg?updatedAt=1763144210729",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/c17683da0fd744356973f9585dabfb77a.jpg?updatedAt=1763144210912",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/1b.jpg?updatedAt=1763144210023",
  "https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/e1e93662bcb2db4b670e4640dbf3a5ffab.jpg?updatedAt=1763144209330"
];
const GalleryPage = () => {
  const { properties, blogPosts, heroSlides, galleryImages, galleryCategories, loading, error } = useData();

  const [category, setCategory] = useState('all');
  const [location, setLocation] = useState('all');

  // Derive unique categories and locations from properties
  const { categories, locations } = useMemo(() => {
    const catSet = new Set();
    const locSet = new Set();
    (properties || []).forEach((p) => {
      if (p.category) catSet.add(p.category);
      if (p.location) locSet.add(p.location);
    });
    (galleryCategories || []).forEach((category) => {
      if (category?.name) catSet.add(category.name);
    });
    (galleryImages || []).forEach((img) => {
      if (img?.category_name) catSet.add(img.category_name);
    });
    return {
      categories: Array.from(catSet),
      locations: Array.from(locSet),
    };
  }, [properties, galleryCategories, galleryImages]);

  // Build the gallery items list according to filters
  const galleryItems = useMemo(() => {
    const items = [];

    // Helper to avoid duplicates
    const pushImage = (url, meta) => {
      if (!url) return;
      items.push({ url, ...meta });
    };

    const categoryFilter = (category || '').toLowerCase();

    // Property images (respect filters)
    (properties || []).forEach((p) => {
      const matchCategory = category === 'all' || p.category === category;
      const matchLocation = location === 'all' || p.location === location;
      if (!matchCategory || !matchLocation) return;

      const seen = new Set();
      if (p.featured_image) {
        seen.add(p.featured_image);
        pushImage(p.featured_image, {
          type: 'property',
          title: p.title,
          subtitle: p.location,
          id: p.id,
          category: p.category,
          location: p.location,
          link: `/property/${p.id}`,
        });
      }
      (p.images || []).forEach((img) => {
        if (img && !seen.has(img)) {
          seen.add(img);
          pushImage(img, {
            type: 'property',
            title: p.title,
            subtitle: p.location,
            id: p.id,
            category: p.category,
            location: p.location,
            link: `/property/${p.id}`,
          });
        }
      });
    });

    // Hero slides (always available, filtered later)
    (heroSlides || []).forEach((s) => {
      if (s.background_image) {
        pushImage(s.background_image, {
          type: 'hero',
          title: s.title,
          subtitle: s.subtitle,
          category: 'Hero Slides',
        });
      }
      if (s.interior_image) {
        pushImage(s.interior_image, {
          type: 'hero',
          title: s.title,
          subtitle: s.subtitle,
          category: 'Hero Slides',
        });
      }
    });

    // Blog featured images
    (blogPosts || []).forEach((b) => {
      if (b.featured_image) {
        pushImage(b.featured_image, {
          type: 'blog',
          title: b.title,
          subtitle: b.excerpt,
          link: `/blog/${b.id}`,
          category: 'Blog Posts',
        });
      }
    });

    const resolveGalleryCategory = (img) => {
      if (img?.category_name) return img.category_name;
      const found = (galleryCategories || []).find((cat) => cat.id === img?.category_id);
      return found?.name || 'Gallery';
    };

    // Managed gallery images from database
    (galleryImages || []).forEach((img) => {
      const resolvedCategory = resolveGalleryCategory(img);
      (img.images || []).forEach((imageUrl) => {
        pushImage(imageUrl, {
          type: 'gallery',
          title: img.title,
          subtitle: img.description || resolvedCategory,
          category: resolvedCategory,
        });
      });
    });

    // Fallback to curated images if no managed gallery images exist
    if (!galleryImages || galleryImages.length === 0) {
      CURATED_GALLERY_IMAGES.forEach((url, index) => {
        pushImage(url, {
          type: 'gallery',
          title: 'Nyinimu Home',
          subtitle: `Showcase ${index + 1}`,
          category: 'Curated Gallery',
        });
      });
    }

    const filteredItems = items.filter((item) => {
      const normalizedCategory = item.category?.toLowerCase();
      const matchesCategory =
        category === 'all' ||
        (normalizedCategory && normalizedCategory === categoryFilter);
      const matchesLocation =
        location === 'all' ||
        (item.location && item.location === location);
      return matchesCategory && matchesLocation;
    });

    return filteredItems;
  }, [properties, blogPosts, heroSlides, galleryImages, galleryCategories, category, location]);

  if (loading) {
    return (
      <div className="pt-24 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-stone-800 mx-auto mb-4"></div>
          <p className="text-stone-600">Loading gallery...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pt-24 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 mb-2">Error loading gallery</p>
          <p className="text-stone-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      <GenericHero
        title="Visual Gallery"
        description="Immerse yourself in our developments, interiors, and project highlights captured across Uganda."
        backgroundVideo="https://ik.imagekit.io/hqhiltiie/Nyinimu/hero%20bg.mp4?updatedAt=1763033048497"
      />

      <div className="relative z-10 -mt-16 bg-white rounded-t-[32px] pt-16">
        {/* Header */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 space-y-6">
          <div className="text-center space-y-2">
            <h1 className="text-3xl md:text-4xl font-semibold tracking-[0.2em] title-font text-[#81be00] flex items-center justify-center gap-2">
              <ImageIcon className="w-7 h-7 text-[#81be00]" /> Our Gallery
            </h1>
            <p className="text-stone-500">Explore our properties, hero slides and blog visuals</p>
          </div>

          <div className="flex flex-wrap items-center justify-end gap-3 sm:gap-4">
            {/* Location Filter */}
            <div className="min-w-[200px]">
              <Select value={location} onValueChange={setLocation}>
                <SelectTrigger className="shadow-sm">
                  <SelectValue placeholder="Location" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Locations</SelectItem>
                  {locations.map((l) => (
                    <SelectItem key={l} value={l}>{l}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* Category Filter */}
            <div className="min-w-[200px]">
              <Select value={category} onValueChange={setCategory}>
                <SelectTrigger className="shadow-sm">
                  <SelectValue placeholder="Category" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Categories</SelectItem>
                  {categories.map((c) => (
                    <SelectItem key={c} value={c}>{c}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* Reset */}
            <Button
              variant="outline"
              onClick={() => { setCategory('all'); setLocation('all'); }}
              className="shadow-sm"
            >
              Reset
            </Button>
          </div>
        </section>

        {/* Masonry Grid */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          {galleryItems.length === 0 ? (
            <div className="text-center text-stone-500 py-20">No images found</div>
          ) : (
            <ModernGallery
              items={galleryItems.map((item, idx) => ({
                src: item.url,
                alt: item.title || `Image ${idx + 1}`,
                caption: item.subtitle || item.category || item.type,
              }))}
            />
          )}
        </section>
      </div>
    </div>
  );
};

export default GalleryPage;
